import { TableProps as AntdTableProps } from 'antd';
import { StyledTable } from './TableStyles';
import { AnyObject } from 'antd/es/_util/type';

export type TableProps<A> = AntdTableProps<A> & {
  loading?: boolean;
};

const Table = <A extends AnyObject>(props: TableProps<A>) => <StyledTable {...props} />;

export default Table;
